import { $pathname, signout } from '@features/common';
import {
  $error,
  $isPopperVisible,
  clearError,
  ContactCallsGate,
  errorOccured,
  setPopperVisiblity,
} from './model';

$isPopperVisible
  .on(setPopperVisiblity, (_, status) => status)
  .reset([signout, $pathname]);

$error
  .on(errorOccured, (_, data) => {
    const { error } = data;

    try {
      return JSON.parse(error?.message ?? '{}');
    } catch {
      return error;
    }
  })
  .reset([clearError, ContactCallsGate.close, signout]);
